import React, {memo} from "react";
import styles from "./styles.module.scss";
import {TextMedium12, TextMedium14} from "@/app/components/texts";

interface Props {
  title: string;
  text: string | number;
}

const UserBigData: React.FC<Props> = ({title, text}) => {
  return (
    <div className={styles.userBigData}>
      <TextMedium12 text={title.toString()} className={styles.title}/>
      <TextMedium14 text={text.toString()} className={styles.text}/>
    </div>
  );
};

export default memo(UserBigData);